/**
 * Formats a number as a currency string.
 * @param amount - The raw number from the API
 * @param currency - 'HNL' or 'USD'
 * @returns Formatted string (e.g., 'L 15,000.00' or '$ 800.50')
 */
export function formatCurrency(amount: number, currency: 'HNL' | 'USD'): string {
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount))

  const sign = amount < 0 ? '-' : ''
  
  if (currency === 'HNL') {
    return `L ${sign}${formatted}`
  }
  
  return `$ ${sign}${formatted}`
}
